<template>
    <div>
        <section>
            <div class="inner row5">
                <div class="title">
                    <h1>제품 관리</h1>
                </div>
                <section>
                    <div class="row4">
                        <div class="topContent flex">
                            <div class="left flex flexAlignC">
                                <p>총 <span>{{ productCnt }}</span>건</p>
                                <div class="radioContentBox">
                                    <div class="radioItem" @click="setTabChange('')">
                                        <input type="radio" id="option1" name="status" checked>
                                        <label for="option1"> 전체 </label>
                                    </div>
                                    <div class="radioItem" @click="setTabChange('APPROVAL')">
                                        <input type="radio" id="option2" name="status">
                                        <label for="option2"> 승인 </label>
                                    </div>
                                    <div class="radioItem" @click="setTabChange('REJECT')">
                                        <input type="radio" id="option3" name="status">
                                        <label for="option3"> 거절 </label>
                                    </div>
                                    <div class="radioItem" @click="setTabChange('STANDBY')">
                                        <input type="radio" id="option4" name="status">
                                        <label for="option4"> 대기 </label>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <input type="text" class="searchInput" v-model="searchText" @keyup.enter="searchTable" />
                                <input type="button" value="검 색" class="searchBtn searchBtnCmmn" @click="searchTable" />
                                <input type="button" value="검색초기화" class="searchResetBtn searchBtnCmmn" @click="resetSearchText" />
                                <div class="btnBox blankLeft inlineB">
                                    <button class="greenBtn smBtn" @click="statusBtn('APPROVAL')">승인</button>
                                    <button class="orangeBtn smBtn" @click="rejectBtn('REJECT')">반려</button>
                                    <ModalProductReject v-if="isShowModalProductReject" @modal-closed='handleModalClosed'/>
                                </div>
                            </div>
                        </div>
                        <div class="tableContainer">
                            <div class="sampleTemplate">
                                <b-table
                                id="table"
                                :fields="fields"
                                :items="getProduct"
                                :per-page="perPage"
                                :current-page="currentPage"
                                @head-clicked="onHeadClicked"
                                @row-clicked="onRowClicked"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :select-mode="selectMode"
                                ref="table"
                                selectable
                                @row-selected="onRowSelected"
                                hover
                                show-empty
                                empty-text="제품이 존재하지 않습니다."
                                >
                                    <template #cell(STATUS)="data">
                                        <span v-html="data.value"></span>
                                    </template>
                                    <template #cell(selected)="{ rowSelected }">
                                        <template v-if="rowSelected">
                                            <span aria-hidden="true">&check;</span>
                                            <span class="sr-only">Selected</span>
                                        </template>
                                        <template v-else>
                                            <span aria-hidden="true">&nbsp;</span>
                                            <span class="sr-only">Not selected</span>
                                        </template>
                                    </template>
                                    <template #cell(NAME)="data">
                                        <span v-html="data.value" @click="showDetail(data.item.IDX)"></span>
                                    </template>
                                </b-table>
                                <b-pagination
                                v-model="currentPage"
                                :total-rows="totalCnt"
                                :per-page="perPage"
                                aria-controls="table">
                                </b-pagination>
                                <div>
                                    <button class="addContentBtn" @click="addConBtn()">항목추가</button>
                                </div>
                            </div>
                            <ModalProductManagement v-if="isShowModalProductManagement" @modal-closed='handleModalClosed'/>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    </div>   
</template>

<script>
import ModalProductManagement from '@/components/managementPopup/ModalProductManagement'
import ModalProductReject from '@/components/managementPopup/ModalProductReject'
import axios from '@/axios/axios'

export default {
    name: 'ProductManagement',
    components: {
        ModalProductManagement,
        ModalProductReject
    },
    data() {
        return {
            isShowModalProductManagement: false,
            isShowModalProductReject: false,
            searchText: this.$route.query.searchText ? this.$route.query.searchText : "",
            status: '',
            totalNo: 1,
            nowPage: 1,
            totalPage: 2,
            perPage: 10,
            currentPage: 1,
            totalCnt: 0,
            productCnt: 0,
            //sortBy: 최초 보이는 화면의 sort 기준, sortDesc 순서
            sortBy: 'IDX',
            sortDesc: false,
            selectMode: 'multi',
            selected: [],
            fields: [
                {
                    key: 'selected',
                    label: '선택',
                    class: 'text-center',
                },
                {
                    key: 'ROWNUM',
                    label: 'No',
                    sortable: false,
                    sortDirection: 'desc',
                    class: 'text-center'
                },
                {
                    key: 'STATUS_STR',
                    label: '상태',
                    sortable: false,
                    isActive: true,
                    class: 'statusOn text-center',
                },
                {
                    key: 'MANUFACTURE_STR',
                    label: '제조구분',
                    sortable: false,
                    class: 'text-center'
                },
                {
                    key: 'NAME',
                    label: '제품명',
                    sortable: false,
                    class: 'text-center'
                },
                {
                    key: 'PRICE',
                    label: '가격',
                    sortable: false,
                    class: 'text-center',
                    formatter(value) {
                        return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ","); //금액 3자리수 콤마
                    }
                },
                {
                    key: 'COMPANY',
                    label: '업체명',
                    sortable: false,
                    class: 'text-center'
                },
                {
                    key: 'REGDATE',
                    label: '등록일',
                    sortable: false,
                    class: 'text-center'
                }
            ]
        }
    },
    methods:{
        // onRowClicked(/*item*/){
        //     //alert('item clicked')
        // },
        onRowSelected(items) {
            this.selected = items
        },
        onHeadClicked(/*selected*/) {
            this.$refs.table.selectAllRows()
        },
        goback(){
            this.$router.go(-1) 
        },
        writeBtn() {
            this.$router.push('/admin/productManagementDetail');
        },
        onRowClicked() {
            //this.$router.push('/admin/noticeManagementDetail');
        },
        addConBtn() {
            this.isShowModalProductManagement = true
        },
        handleModalClosed(value){
			if(value === ModalProductManagement.name){
				this.isShowModalProductManagement = false
			}
            if(value === ModalProductReject.name){
                this.isShowModalProductReject = false
            }
		},
        getProduct(){
            return axios
                .post('/api/admin/product/getProductList', {
                    currentPage: this.currentPage,
                    perPage: this.perPage,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc,
                    searchText : this.searchText,
                    status : this.status
                })
                .then(response => {
                    const items = response.data.items;
                    this.totalCnt = response.data.totalCnt;                    
                    this.productCnt = response.data.productCnt;                    
                    return items;
                })
                .catch(error => {
                    console.log("error: "+error)
                    return []
                })
        },
        resetSearchText(){
            this.searchText = "";
            this.searchTable();
        },
        searchTable(){
            let path = `/admin/productManagement?searchText=${this.searchText}`;
            if (this.$route.fullPath !== path){
                this.$router.push({ path:'/admin/productManagement', query: { searchText : this.searchText }});
            }
            this.$refs.table.refresh();
        },
        setTabChange(status) {
            this.status = status;
            this.currentPage = 1;
            this.$refs.table.refresh();
        },
        statusBtn(status) {
            let selected = this.selected;
            if(selected.length == 0){
                this.$alert("알림", "처리할 항목을 선택해주세요.");
                return false;
            }



            return axios
                .post('/api/admin/product/updateState', {
                    status: status,
                    selectedList : selected
                })
                .then(response => {
                    console.log("response: "+response)
                    this.$refs.table.refresh();
                    this.$alert("알림", "상태 처리가 완료되었습니다.");
                })
                .catch(error => {
                    console.log("error: "+error)
                    return []
                })
        },
        showDetail(idx){
            this.$router.push({ path : '/admin/productDetail/'+idx });
        },
        rejectBtn() {
            let selected = this.selected;
            if(selected.length == 0){
                this.$alert("알림", "처리할 항목을 선택해주세요.");
                return false;
            }
            this.isShowModalProductReject = true
        }
    }
}
</script>

<style scoped lang="scss">
    .sampleTemplate ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
    }
</style>